/**
 * Site iletişim bilgileri — bot-resistant SSoT.
 *
 * Tüm public-facing iletişim bilgileri (e-posta, telefon, KEP) bot harvester'lardan
 * korumak için parça-parça (tuple) saklanır. <ObfuscatedEmail> ve <ObfuscatedPhone>
 * component'leri bu parçaları client-side birleştirir; SSR HTML'de hiç görünmez.
 *
 * Pattern: dynamic({ ssr: false }) → SSR'da component render edilmez,
 * sadece browser hydrate sonrası birleşir. Bot HTML kaynağında e-posta/telefon yok.
 */

/** E-posta parçaları — `${parts[0]}@${parts.slice(1).join('.')}` formatı. */
export const DESTEK_EMAIL_PARTS = ['destek', 'riskmatik', 'com'] as const;
export const INFO_EMAIL_PARTS = ['info', 'riskmatik', 'com'] as const;
export const YARDIM_EMAIL_PARTS = ['yardim', 'riskmatik', 'com'] as const;
export const KEP_EMAIL_PARTS = ['ali.zorlu.7', 'hs01', 'kep', 'tr'] as const;

/** Telefon parçaları — display için ' ' join, tel: href için '' join + '+' prefix. */
export const TELEFON_PARTS = ['90', '535', '256', '21', '15'] as const;

/** WhatsApp link için. Telefon ile aynı raw — sadece wa.me URL pattern'i için. */
export const SITE_WHATSAPP = '+90 535 256 21 15';
export const SITE_CONTACT_URL = 'https://www.riskmatik.com/iletisim';
